import { observable } from "mobx";
import { GET } from "lib/api";

class SettingStore {
  @observable settings = [];

  async init() {
    if (this.settings.length === 0) {
      let res = await GET("v1/adminsettings/");
      this.settings = res.settings;
    }
  }

  getSettingValue(name) {
    let row = this.settings?.find((s) => s.settingName === name);
    return row?.settingValue;
  }

  isBt() {
    return this.getSettingValue("bt") === "1";
  }
}

export default new SettingStore();
